import CargaItemProduto from "./carga_item_produto";

export default interface CargaItem {
  e_reentrega: string;
  pedido_numero: string;
  pedido_tipo_documento: string;
  pedido_tipo_documento_nome: string;
  pedido_entrada_e_saida_gera_financeiro: string;
  pedido_motivo_da_troca: string;
  pedido_status_agendamento: string;
  j07_ukey: string;
  j10_ukey: string;
  j14_ukey: string;
  carga_numero: string;
  carga_item_ordem_entrega: string;
  e_nota_pallet: string;
  nota_numero: string;
  nota_financeiro_recebido_antecipadamente: string;
  cliente_ukey?: string;
  cliente_cnpj: string;
  cliente_celular: string;
  cliente_razao_social: string;
  cliente_fantasia: string;
  cliente_endereco: string;
  cliente_bairro: string;
  cliente_numero: string;
  cliente_cep: string;
  cliente_cidade: string;
  cliente_uf: string;
  cliente_latitude: string;
  cliente_longitude: string;
  vendedor_codigo: string;
  vendedor_nome: string;
  vendedor_celular: string;
  complemento_hora_recebimento_inicial_1: string;
  complemento_hora_recebimento_final_1: string;
  complemento_hora_recebimento_inicial_2: string;
  complemento_hora_recebimento_final_2: string;
  complemento_observacao_entrega: string;
  complemento_nao_abre_segunda: string;
  complemento_nao_abre_terca: string;
  complemento_nao_abre_quarta: string;
  complemento_nao_abre_quinta: string;
  complemento_nao_abre_sexta: string;
  complemento_nao_abre_sabado: string;
  complemento_nao_abre_domingo: string;
  nota_dados_complementares_entrega_motorista_agrupamento: string;
  nota_dados_complementares_entrega_celular_motorista_agrupamento: string;
  nota_dados_complementares_entrega_link_app: string;
  produtos?: CargaItemProduto[];
  questionario_ja_respondido?: string | number | boolean;
}

export function getOrdemEntrega(item: CargaItem): number {
  return parseInt(item.carga_item_ordem_entrega || "0", 10);
}